export default __webpack_public_path__ + "static/media/elaine_chen.32b4308e.jpg";